import { Button, Modal, Row, Col, Select, Input, Flex, message, Popconfirm, Slider, SliderSingleProps, Tag, Card, Avatar, Typography } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { SlidersOutlined, PlayCircleOutlined, HeartOutlined, HeartFilled, FilterOutlined, UserOutlined, PauseCircleOutlined, DownOutlined, UpOutlined } from '@ant-design/icons'
import { languages, voiceFilter } from '@src/shared/utils/aiVoiceFilter'
import { formatDuration } from '@src/shared/utils/convertSecs'
import {
  deleteFavouredVoice,
  getFavouredVoices,
  saveFavoriteVoices,
} from '@src/shared/utils/VideoGeneration/helperFunctions/voiceFavorite'
import { getClonedVoices } from '@src/shared/utils/VideoGeneration/helperFunctions/voiceCloneApi'
import { AnyMxRecord } from 'dns'
import './audioFilterModal.less'
const { Option } = Select
const { Search } = Input
interface FavouredVoiceData {
  user_id: string
  voice_name: string | null
  createdAt: string
  id: string
  voice_id: string | null
  updatedAt: string | null
}
export const VoiceFilterModal = ({ aiVoice, handleChangeVoice, selectedVoiceName }: any) => {
  console.log(aiVoice)
  const formatter: NonNullable<SliderSingleProps['tooltip']>['formatter'] = (value: any) => `${value}%`

  // Recommended voice IDs
  const recommendedFemaleVoices = [
    'ZT9u07TYPVl83ejeLakq', // Rachelle
    'PoHUWWWMHFrA8z7Q88pu', // Miranda
    'pGAwIQNN9UjOkKxjAyGQ', // Amelia - Gentle and Emotive
    'S9EGwlCtMF7VXtENq79v', // Emma Taylor
    'SaqYcK3ZpDKBAImA8AdW', // Jane Doe - Intimate
    'rCmVtv8cYU60uhlsOo1M', // Ana
    'QwvsCFsQcnpWxmP1z7V9', // LavenderLessons
    'WonySogMOJVSOnlOGFQh', // Amber Quill: An Enchanting and Soothing Narrator
    'xctasy8XvGp2cVO9HL9k', // Allison - millennial
    'qBDvhofpxp92JgXJxDjB', // Lily Wolff - Expressive, Clear, Youthful
    'KaCAGkAghyX8sFEYByRC', // Mridula - Warm Storytelling Voice
    'aAzJB4KWAzCZrJSxdt5x', // Tarini - Expressive & Cheerful Narrator
    'P7vsEyTOpZ6YUTulin8m', // Tara - Conversational Expressive Voice
    'UYoWPkHjaRgjWccloxC5', // Monika Sogam - Social Media Voice
  ]

  const recommendedMaleVoices = [
    'WTUK291rZZ9CLPCiFTfh', // Mark
    'wBXNqKUATyqu0RtYt25i', // Adam – Warm and conversational
    '8JVbfL6oEdmuxKn5DK2C', // Johnny Kid - Serious
    'PSqRw3ln34TxQZrTS6Wt', // Andy - Upbeat & Expressive
    'WWr4C8ld745zI3BiA8n7', // Robert Riggs
    'baRq1qg6PxLsnSQ04d8c', // Axl – Expressive & Versatile
    'sflYrWiXii4ezPjNLQkp', // Todd Thomas
    'dyTPmGzuLaJM15vpN3DS', // Aiden - Happy Video Host
    'w0IiOWjSOKxZ9DKU0t5G', // Robby
    'raMcNf2S8wCmuaBcyI6E', // Tyler Kurk
    'XdxYCbvu4pF876vgEQRe', // Kade Murdock HQ
    'BZ7QSotEmGyFMP8nbbhC', // Jackie Shaw - Energetic & Friendly
    'JZ3e95uoTACVf6tXaaEi', // Johnny - Upbeat Professional American
  ]

  const filterVariables = voiceFilter(aiVoice)
  const [voicesOpen, setVoicesOpen] = useState(false)
  const [selectedAccent, setSelectedAccent] = useState<string | undefined>(undefined)
  const [playingUrl, setPlayingUrl] = useState('')
  const [selectedAge, setSelectedAge] = useState<string | undefined>(undefined)
  const [selectedGender, setSelectedGender] = useState<string | undefined>(undefined)
  const [selectedUseCase, setSelectedUseCase] = useState<string | undefined>(undefined)
  const [selectedLanguage, setSelectedLanguage] = useState<string | undefined>(undefined)
  const [searchQuery, setSearchQuery] = useState<string>('')
  const [favouredVoices, setFavouredVoices] = useState<FavouredVoiceData[]>([])
  const [clonedVoices, setClonedVoices] = useState<any[]>([])

  const audioRef = useRef<HTMLAudioElement | null>(null)

  const [Stability, setstability] = useState(50)
  const [Similarity, setsimilarity] = useState(75)
  const [isRecommendedCollapsed, setIsRecommendedCollapsed] = useState(false)

  const handleCancel = () => {
    setVoicesOpen(false)
  }

  useEffect(() => {
    async function favouredVoices() {
      try {
        const favouredVoices = await getFavouredVoices()
        setFavouredVoices(favouredVoices)
      } catch {
        console.error('Failed to get favorite voices.')
      }
    }

    async function fetchClonedVoices() {
      try {
        const clonedVoicesData = await getClonedVoices()
        if (clonedVoicesData !== -1) {
          setClonedVoices(clonedVoicesData)
        }
      } catch {
        console.error('Failed to get cloned voices.')
      }
    }

    favouredVoices()
    fetchClonedVoices()
  }, [])

  const handleFavoriteDelete = async (id: string) => {
    try {
      // Assuming you have a backend API call to delete by voice_id
      await deleteFavouredVoice(id)
      setFavouredVoices((prevData) => prevData.filter((voice) => voice.id !== id))
    } catch (error) {
      message.warning('There was a problem deleting the cloned voice.')
    }
  }
  const handleFilterChange = (value: string, filterType: string) => {
    switch (filterType) {
      case 'Accent':
        setSelectedAccent(value)
        break
      case 'Age':
        setSelectedAge(value)
        break
      case 'Gender':
        setSelectedGender(value)
        break
      case 'UseCase':
        setSelectedUseCase(value)
        break
      case 'Language':
        setSelectedLanguage(value)
        break
      default:
        break
    }
  }
  const filteredVoices = aiVoice
    .filter((voice: any) => voice?.category !== 'cloned')
    .filter((voice: any) => {
      const voiceLabels = voice.labels || {}
      const matchesAccent = selectedAccent ? voiceLabels.accent === selectedAccent || selectedAccent === 'All' : true
      const matchesAge = selectedAge ? voiceLabels.age === selectedAge || selectedAge === 'All' : true
      const matchesGender = selectedGender ? voiceLabels.gender === selectedGender || selectedGender === 'All' : true
      const matchesUseCase = selectedUseCase
        ? voiceLabels.use_case === selectedUseCase || selectedUseCase === 'All'
        : true
      const matchesSearchQuery = searchQuery ? voice?.name.toLowerCase().includes(searchQuery.toLowerCase()) : true
      const matchesLanguages = selectedLanguage
        ? voice.fine_tuning?.language === selectedLanguage || selectedLanguage === 'All'
        : true
      return matchesAccent && matchesAge && matchesGender && matchesUseCase && matchesSearchQuery && matchesLanguages
    })

  // Get cloned voices that match IDs from aiVoice list
  const clonedVoicesFromAiVoice = aiVoice.filter((voice: any) => {
    const clonedVoiceIds = clonedVoices.map(cv => cv.voice_id)
    return clonedVoiceIds.includes(voice.voice_id) && voice?.category === 'cloned'
  }).filter((voice: any) => {
    const matchesSearchQuery = searchQuery ? voice?.name.toLowerCase().includes(searchQuery.toLowerCase()) : true
    return matchesSearchQuery
  })

  // Get recommended voices from the aiVoice list
  const getRecommendedVoices = (voiceIds: string[]) => {
    return aiVoice.filter((voice: any) => 
      voiceIds.includes(voice.voice_id) && voice?.category !== 'cloned'
    )
  }

  const recommendedFemales = getRecommendedVoices(recommendedFemaleVoices)
  const recommendedMales = getRecommendedVoices(recommendedMaleVoices)

  const modalTitle = (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center',
      padding: '16px 0',
      borderBottom: '1px solid var(--color-primary-100)'
    }}>
      <div style={{ 
        fontSize: '18px',
        fontWeight: 600,
        color: 'var(--color-primary-800)',
        fontFamily: 'DM Sans'
      }}>
        AI Voices
      </div>
    </div>
  )

  const handleToggleFavorite = async (e: any, voice_id: string, voice_name: string, id: string) => {
    e.stopPropagation()

    const isFavorite = favouredVoices.some((favVoice) => favVoice.voice_id === voice_id)
    const favouredVoice = favouredVoices?.find((favVoice: any) => favVoice.voice_id === voice_id)
    const favoriteId = favouredVoice ? favouredVoice.id : ''

    if (isFavorite) {
      handleFavoriteDelete(favoriteId)
    } else {
      try {
        await saveFavoriteVoices(voice_name, voice_id)
        // setFavouredVoices((prevData:any) => [
        //   ...prevData,
        //   { voice_id:voice_id, voice_name:voice_name, id: favoriteId  } // Ensure you add an id for new entries
        // ]);
        const favouredVoices = await getFavouredVoices()

        setFavouredVoices(favouredVoices)
      } catch {
        message.error('Failed to mark favorite.')
      }
    }
  }
  const handlePlayAudioTwo = (previewUrl: string) => {
    if (audioRef.current) {
      audioRef.current.src = previewUrl

      audioRef.current.addEventListener('loadedmetadata', () => {
        // Log duration
      })
      audioRef.current.play().catch((e: any) => console.error('Playback was interrupted:', e))
      setPlayingUrl(previewUrl)
    }
  }

  const toggleRecommendedSection = () => {
    setIsRecommendedCollapsed(!isRecommendedCollapsed)
  }

  return (
    <>
      <Button
        onClick={() => setVoicesOpen(true)}
        style={{
          background: 'white',
          borderColor: 'var(--color-primary-200)',
          color: 'var(--color-primary-600)',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          padding: '4px 12px',
          height: '32px'
        }}
      >
        <FilterOutlined />
        Filter
      </Button>

      <Modal
        title={modalTitle}
        width={1200}
        open={voicesOpen}
        cancelText={'Close'}
        onCancel={handleCancel}
        styles={{ 
          body: { 
            maxHeight: '75vh', 
            overflowY: 'auto',
            padding: '24px',
            background: 'var(--color-surface)'
          },
          header: {
            padding: '0 24px',
            marginBottom: '0'
          },
          footer: {
            padding: '16px 24px',
            background: 'white',
            borderTop: '1px solid var(--color-primary-100)'
          }
        }}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <Button 
              onClick={handleCancel}
              style={{
                borderRadius: '8px',
                borderColor: 'var(--color-primary-200)',
                color: 'var(--color-primary-800)'
              }}
            >
              Close
            </Button>
          </>
        )}
      >
        <div style={{ background: 'white', padding: '24px', borderRadius: '12px', marginBottom: '24px' }}>
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <Search
                placeholder='Search by Name'
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ width: '100%' }}
                className="voice-search-input"
                allowClear
              />
            </Col>

            <Col span={4}>
              <Select
                placeholder='Select Language'
                onChange={(value) => handleFilterChange(value, 'Language')}
                style={{ width: '100%' }}
                popupMatchSelectWidth={false}
              >
                <Option key={'default'} value={'All'}>All Languages</Option>
                {languages.map((language: any, index: any) => (
                  <Option key={index} value={language.value}>{language.label}</Option>
                ))}
              </Select>
            </Col>

            <Col span={4}>
              <Select
                placeholder='Select Accent'
                onChange={(value) => handleFilterChange(value, 'Accent')}
                style={{ width: '100%' }}
                popupMatchSelectWidth={false}
              >
                <Option key={'default'} value={'All'}>All Accents</Option>
                {filterVariables?.accents
                  .filter((accent: any): accent is string => accent !== undefined)
                  .map((accent: any) => (
                    <Option key={accent} value={accent}>{accent}</Option>
                  ))}
              </Select>
            </Col>

            <Col span={4}>
              <Select
                placeholder='Select Age'
                onChange={(value) => handleFilterChange(value, 'Age')}
                style={{ width: '100%' }}
                popupMatchSelectWidth={false}
              >
                <Option key={'default'} value={'All'}>All Ages</Option>
                {filterVariables?.ages
                  .filter((age: any): age is string => age !== undefined)
                  .map((age: any) => (
                    <Option key={age} value={age}>{age}</Option>
                  ))}
              </Select>
            </Col>

            <Col span={4}>
              <Select
                placeholder='Select Gender'
                onChange={(value) => handleFilterChange(value, 'Gender')}
                style={{ width: '100%' }}
                popupMatchSelectWidth={false}
              >
                <Option key={'default'} value={'All'}>All Genders</Option>
                {filterVariables?.genders
                  .filter((gender: any): gender is string => gender !== undefined)
                  .map((gender: any) => (
                    <Option key={gender} value={gender}>{gender}</Option>
                  ))}
              </Select>
            </Col>

            <Col span={4}>
              <Select
                placeholder='Select Use case'
                onChange={(value) => handleFilterChange(value, 'UseCase')}
                style={{ width: '100%' }}
                popupMatchSelectWidth={false}
              >
                <Option key={'default'} value={'All'}>All Use Cases</Option>
                {filterVariables?.usecases
                  .filter((usecase: any): usecase is string => usecase !== undefined)
                  .map((usecase: any) => (
                    <Option key={usecase} value={usecase}>{usecase}</Option>
                  ))}
              </Select>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
            <Col span={12}>
              <div style={{ background: 'var(--color-surface)', padding: '16px', borderRadius: '8px' }}>
                <p style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  color: 'var(--color-primary-800)',
                  marginBottom: '12px'
                }}>
                  Stability
                </p>
                <Slider
                  style={{ width: '100%' }}
                  min={0}
                  max={100}
                  onChange={(value) => setstability(value)}
                  value={Stability}
                  tooltip={{ formatter }}
                  marks={{
                    0: { label: 'Variable', style: { color: 'var(--color-primary-600)' } },
                    100: { label: 'Stable', style: { color: 'var(--color-primary-600)' } }
                  }}
                />
              </div>
            </Col>
            <Col span={12}>
              <div style={{ background: 'var(--color-surface)', padding: '16px', borderRadius: '8px' }}>
                <p style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  color: 'var(--color-primary-800)',
                  marginBottom: '12px'
                }}>
                  Similarity
                </p>
                <Slider
                  style={{ width: '100%' }}
                  min={0}
                  max={100}
                  value={Similarity}
                  onChange={(value) => setsimilarity(value)}
                  tooltip={{ formatter }}
                  marks={{
                    0: { label: 'Low', style: { color: 'var(--color-primary-600)' } },
                    100: { label: 'High', style: { color: 'var(--color-primary-600)' } }
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>

        {/* Recommended Voices Section */}
        <div style={{ 
          background: 'white', 
          padding: '24px', 
          borderRadius: '12px', 
          marginBottom: '24px',
          border: '2px solid var(--color-primary-200)'
        }}>
          <div 
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: isRecommendedCollapsed ? '0' : '20px',
              cursor: 'pointer'
            }}
            onClick={toggleRecommendedSection}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <div style={{
                width: '4px',
                height: '24px',
                background: 'linear-gradient(135deg, var(--color-primary-500), var(--color-primary-600))',
                borderRadius: '2px'
              }} />
              <h2 style={{
                margin: 0,
                fontSize: '20px',
                fontWeight: 700,
                color: 'var(--color-primary-800)',
                fontFamily: 'DM Sans'
              }}>
                ✨ Recommended Voices
              </h2>
            </div>
            <Button
              type="text"
              icon={isRecommendedCollapsed ? <DownOutlined /> : <UpOutlined />}
              style={{
                color: 'var(--color-primary-600)',
                fontSize: '16px',
                padding: '4px 8px'
              }}
            />
          </div>

          {!isRecommendedCollapsed && (
            <>
              {/* Female Recommended Voices */}
              {recommendedFemales.length > 0 && (
                <div style={{ marginBottom: '32px' }}>
                  <h3 style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: 'var(--color-primary-700)',
                    marginBottom: '16px',
                    fontFamily: 'DM Sans'
                  }}>
                    👩 Female Voices
                  </h3>
                  <Row gutter={[16, 16]}>
                    {recommendedFemales.map((voice: any, index: number) => (
                      <Popconfirm
                        title='Sure to change?'
                        onConfirm={() => handleChangeVoice(voice.voice_id, Similarity, Stability)}
                        key={`female-${index}`}
                      >
                        <Col xs={24} sm={12} md={8} lg={6} key={`female-${index}`} style={{ cursor: 'pointer' }}>
                          <Card
                            className="voice-card"
                            style={{
                              padding: '16px',
                              background: 'linear-gradient(135deg, #fdf2f8, #fce7f3)',
                              borderRadius: '12px',
                              border: selectedVoiceName === voice.name 
                                ? '2px solid var(--color-primary-600)'
                                : '2px solid #ec4899',
                              boxShadow: '0 4px 12px rgba(236, 72, 153, 0.1)',
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginBottom: '12px'
                            }}>
                              <h3 style={{
                                margin: 0,
                                fontSize: '16px',
                                fontWeight: 600,
                                color: '#831843'
                              }}>
                                {voice?.name}
                              </h3>
                              <Button
                                type='text'
                                icon={
                                  favouredVoices?.some((favVoice) => favVoice.voice_id === voice.voice_id)
                                    ? <HeartFilled style={{ color: '#ff4d4f', fontSize: '18px' }} />
                                    : <HeartOutlined style={{ fontSize: '18px' }} />
                                }
                                onClick={(e) => handleToggleFavorite(e, voice.voice_id, voice.name, voice.id)}
                                style={{ padding: 4 }}
                              />
                            </div>

                            <div style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: '6px',
                              marginBottom: '12px'
                            }}>
                              {voice.labels?.accent && (
                                <Tag color="magenta">{voice.labels.accent}</Tag>
                              )}
                              {voice.labels?.age && (
                                <Tag color="cyan">{voice.labels.age}</Tag>
                              )}
                              {voice.labels?.gender && (
                                <Tag color="volcano">{voice.labels.gender}</Tag>
                              )}
                              {voice?.fine_tuning?.language && (
                                <Tag color="blue">{voice.fine_tuning.language}</Tag>
                              )}
                              {voice.labels?.use_case && (
                                <Tag color="green">{voice.labels.use_case}</Tag>
                              )}
                            </div>

                            <Button
                              type='text'
                              icon={playingUrl === voice.preview_url ? 
                                <PauseCircleOutlined style={{ fontSize: '20px' }} /> : 
                                <PlayCircleOutlined style={{ fontSize: '20px' }} />
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                if (playingUrl === voice.preview_url) {
                                  if (audioRef.current) {
                                    audioRef.current.pause();
                                    setPlayingUrl('');
                                  }
                                } else {
                                  setPlayingUrl(voice.preview_url);
                                  handlePlayAudioTwo(voice.preview_url);
                                }
                              }}
                              className="play-sample-button"
                              style={{
                                width: '100%',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#831843',
                                background: 'rgba(236, 72, 153, 0.1)',
                                borderRadius: '8px',
                                border: '1px solid rgba(236, 72, 153, 0.2)'
                              }}
                            >
                              {playingUrl === voice.preview_url ? 'Pause' : 'Play Sample'}
                            </Button>
                          </Card>
                        </Col>
                      </Popconfirm>
                    ))}
                  </Row>
                </div>
              )}

              {/* Male Recommended Voices */}
              {recommendedMales.length > 0 && (
                <div>
                  <h3 style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: 'var(--color-primary-700)',
                    marginBottom: '16px',
                    fontFamily: 'DM Sans'
                  }}>
                    👨 Male Voices
                  </h3>
                  <Row gutter={[16, 16]}>
                    {recommendedMales.map((voice: any, index: number) => (
                      <Popconfirm
                        title='Sure to change?'
                        onConfirm={() => handleChangeVoice(voice.voice_id, Similarity, Stability)}
                        key={`male-${index}`}
                      >
                        <Col xs={24} sm={12} md={8} lg={6} key={`male-${index}`} style={{ cursor: 'pointer' }}>
                          <Card
                            className="voice-card"
                            style={{
                              padding: '16px',
                              background: 'linear-gradient(135deg, #eff6ff, #dbeafe)',
                              borderRadius: '12px',
                              border: selectedVoiceName === voice.name 
                                ? '2px solid var(--color-primary-600)'
                                : '2px solid #3b82f6',
                              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.1)',
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginBottom: '12px'
                            }}>
                              <h3 style={{
                                margin: 0,
                                fontSize: '16px',
                                fontWeight: 600,
                                color: '#1e40af'
                              }}>
                                {voice?.name}
                              </h3>
                              <Button
                                type='text'
                                icon={
                                  favouredVoices?.some((favVoice) => favVoice.voice_id === voice.voice_id)
                                    ? <HeartFilled style={{ color: '#ff4d4f', fontSize: '18px' }} />
                                    : <HeartOutlined style={{ fontSize: '18px' }} />
                                }
                                onClick={(e) => handleToggleFavorite(e, voice.voice_id, voice.name, voice.id)}
                                style={{ padding: 4 }}
                              />
                            </div>

                            <div style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: '6px',
                              marginBottom: '12px'
                            }}>
                              {voice.labels?.accent && (
                                <Tag color="magenta">{voice.labels.accent}</Tag>
                              )}
                              {voice.labels?.age && (
                                <Tag color="cyan">{voice.labels.age}</Tag>
                              )}
                              {voice.labels?.gender && (
                                <Tag color="volcano">{voice.labels.gender}</Tag>
                              )}
                              {voice?.fine_tuning?.language && (
                                <Tag color="blue">{voice.fine_tuning.language}</Tag>
                              )}
                              {voice.labels?.use_case && (
                                <Tag color="green">{voice.labels.use_case}</Tag>
                              )}
                            </div>

                            <Button
                              type='text'
                              icon={playingUrl === voice.preview_url ? 
                                <PauseCircleOutlined style={{ fontSize: '20px' }} /> : 
                                <PlayCircleOutlined style={{ fontSize: '20px' }} />
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                if (playingUrl === voice.preview_url) {
                                  if (audioRef.current) {
                                    audioRef.current.pause();
                                    setPlayingUrl('');
                                  }
                                } else {
                                  setPlayingUrl(voice.preview_url);
                                  handlePlayAudioTwo(voice.preview_url);
                                }
                              }}
                              className="play-sample-button"
                              style={{
                                width: '100%',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#1e40af',
                                background: 'rgba(59, 130, 246, 0.1)',
                                borderRadius: '8px',
                                border: '1px solid rgba(59, 130, 246, 0.2)'
                              }}
                            >
                              {playingUrl === voice.preview_url ? 'Pause' : 'Play Sample'}
                            </Button>
                          </Card>
                        </Col>
                      </Popconfirm>
                    ))}
                  </Row>
                </div>
              )}
            </>
          )}
        </div>

        {/* Cloned Voices Section */}
        {clonedVoicesFromAiVoice.length > 0 && (
          <div style={{ 
            background: 'white', 
            padding: '24px', 
            borderRadius: '12px',
            border: '1px solid var(--color-primary-100)',
            marginBottom: '20px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '20px',
              gap: '8px'
            }}>
              <div style={{
                width: '4px',
                height: '24px',
                background: 'var(--color-secondary-500)',
                borderRadius: '2px'
              }} />
              <h2 style={{
                margin: 0,
                fontSize: '18px',
                fontWeight: 600,
                color: 'var(--color-primary-800)',
                fontFamily: 'DM Sans'
              }}>
                <UserOutlined style={{ marginRight: '8px' }} />
                My Cloned Voices
              </h2>
            </div>

            <Row gutter={[16, 16]}>
              {clonedVoicesFromAiVoice.map((voice: any, index: number) => (
                <Popconfirm
                  title='Sure to change?'
                  onConfirm={() => handleChangeVoice(voice.voice_id, Similarity, Stability)}
                  key={index}
                >
                  <Col xs={24} sm={12} md={8} lg={6} key={index} style={{ cursor: 'pointer' }}>
                    <Card
                      className="voice-card"
                      style={{
                        padding: '16px',
                        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                        borderRadius: '12px',
                        border: selectedVoiceName === voice.name 
                          ? '2px solid var(--color-secondary-600)'
                          : '1px solid var(--color-secondary-200)',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '12px'
                      }}>
                        <h3 style={{
                          margin: 0,
                          fontSize: '16px',
                          fontWeight: 600,
                          color: 'var(--color-primary-800)'
                        }}>
                          {voice?.name}
                        </h3>
                        <UserOutlined style={{ 
                          fontSize: '18px', 
                          color: 'var(--color-secondary-600)' 
                        }} />
                      </div>

                      <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '6px',
                        marginBottom: '12px'
                      }}>
                        <Tag color="purple">Cloned</Tag>
                        {voice.labels?.gender && (
                          <Tag color="volcano">{voice.labels.gender}</Tag>
                        )}
                        {voice?.fine_tuning?.language && (
                          <Tag color="blue">{voice.fine_tuning.language}</Tag>
                        )}
                      </div>

                      <Button
                        type='text'
                        icon={playingUrl === voice.preview_url ? 
                          <PauseCircleOutlined style={{ fontSize: '20px' }} /> : 
                          <PlayCircleOutlined style={{ fontSize: '20px' }} />
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          if (playingUrl === voice.preview_url) {
                            if (audioRef.current) {
                              audioRef.current.pause();
                              setPlayingUrl('');
                            }
                          } else {
                            setPlayingUrl(voice.preview_url);
                            handlePlayAudioTwo(voice.preview_url);
                          }
                        }}
                        className="play-sample-button"
                        style={{
                          width: '100%',
                          height: '36px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'var(--color-secondary-600)',
                          background: 'var(--color-secondary-50)',
                          borderRadius: '8px'
                        }}
                      >
                        {playingUrl === voice.preview_url ? 'Pause' : 'Play Sample'}
                      </Button>
                    </Card>
                  </Col>
                </Popconfirm>
              ))}
            </Row>
          </div>
        )}

        {/* All Voices Section */}
        <div style={{ 
          background: 'white', 
          padding: '24px', 
          borderRadius: '12px',
          border: '1px solid var(--color-primary-100)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px',
            gap: '8px'
          }}>
            <div style={{
              width: '4px',
              height: '24px',
              background: 'var(--color-primary-500)',
              borderRadius: '2px'
            }} />
            <h2 style={{
              margin: 0,
              fontSize: '18px',
              fontWeight: 600,
              color: 'var(--color-primary-800)',
              fontFamily: 'DM Sans'
            }}>
              All Voices
            </h2>
          </div>

          <Row gutter={[16, 16]}>
            {filteredVoices
              .filter((voice: any) => voice?.category !== 'cloned')
              .map((voice: any, index: number) => (
                <Popconfirm
                  title='Sure to change?'
                  onConfirm={() => handleChangeVoice(voice.voice_id, Similarity, Stability)}
                  key={index}
                >
                  <Col xs={24} sm={12} md={8} lg={6} key={index} style={{ cursor: 'pointer' }}>
                    <Card
                      className="voice-card"
                      style={{
                        padding: '16px',
                        background: 'white',
                        borderRadius: '12px',
                        border: selectedVoiceName === voice.name 
                          ? '2px solid var(--color-primary-600)'
                          : '1px solid var(--color-primary-100)',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '12px'
                      }}>
                        <h3 style={{
                          margin: 0,
                          fontSize: '16px',
                          fontWeight: 600,
                          color: 'var(--color-primary-800)'
                        }}>
                          {voice?.name}
                        </h3>
                        <Button
                          type='text'
                          icon={
                            favouredVoices?.some((favVoice) => favVoice.voice_id === voice.voice_id)
                              ? <HeartFilled style={{ color: '#ff4d4f', fontSize: '18px' }} />
                              : <HeartOutlined style={{ fontSize: '18px' }} />
                          }
                          onClick={(e) => handleToggleFavorite(e, voice.voice_id, voice.name, voice.id)}
                          style={{ padding: 4 }}
                        />
                      </div>

                      <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '6px',
                        marginBottom: '12px'
                      }}>
                        {voice.labels?.accent && (
                          <Tag color="magenta">{voice.labels.accent}</Tag>
                        )}
                        {voice.labels?.age && (
                          <Tag color="cyan">{voice.labels.age}</Tag>
                        )}
                        {voice.labels?.gender && (
                          <Tag color="volcano">{voice.labels.gender}</Tag>
                        )}
                        {voice?.fine_tuning?.language && (
                          <Tag color="blue">{voice.fine_tuning.language}</Tag>
                        )}
                        {voice.labels?.use_case && (
                          <Tag color="green">{voice.labels.use_case}</Tag>
                        )}
                      </div>

                      <Button
                        type='text'
                        icon={playingUrl === voice.preview_url ? 
                          <PauseCircleOutlined style={{ fontSize: '20px' }} /> : 
                          <PlayCircleOutlined style={{ fontSize: '20px' }} />
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          if (playingUrl === voice.preview_url) {
                            // If this voice is already playing, pause it
                            if (audioRef.current) {
                              audioRef.current.pause();
                              setPlayingUrl('');
                            }
                          } else {
                            // Otherwise start playing this voice
                            setPlayingUrl(voice.preview_url);
                            handlePlayAudioTwo(voice.preview_url);
                          }
                        }}
                        className="play-sample-button"
                        style={{
                          width: '100%',
                          height: '36px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'var(--color-primary-600)',
                          background: 'var(--color-surface)',
                          borderRadius: '8px'
                        }}
                      >
                        {playingUrl === voice.preview_url ? 'Pause' : 'Play Sample'}
                      </Button>
                    </Card>
                  </Col>
                </Popconfirm>
              ))}
          </Row>
        </div>
      </Modal>
      <audio ref={audioRef} style={{ display: 'none' }} />
    </>
  )
}
